import AchievementSystemIcon from '@material-ui/icons/EmojiEvents';
import { APP_TYPES, roles } from '../../../config/constants';
import AchievementSystemReportsList from './components/AchievementSystemReportsList';

const options = {
  appTypes: [APP_TYPES.HUNGARY],
  allowedRoles: [roles.ADMIN],
  label: 'Achievement system',
  subMenuName: 'reports',
};

export default {
  list: AchievementSystemReportsList,
  icon: AchievementSystemIcon,
  name: 'admin/reports/achievement-system',
  options,
};
